import React from 'react'
import * as S from './style'

const ButtonCaret = ({ onClick, status }) => (
  <>
    <S.Button title="Detalhar" onClick={onClick}>
      <S.P>{status ? <S.CaretDownStyled /> : <S.CaretLeftStyled />}</S.P>
    </S.Button>
  </>
)

export { ButtonCaret }
